import { AutogenModelOrderType, AutogenRowOrderType } from "./autogen/AutogenModelOrderType";

export class ModelOrderType extends AutogenModelOrderType<RowOrderType> {
    constructor() {
        super(RowOrderType);
    }
}

export class RowOrderType extends AutogenRowOrderType {
}